import { useMemo } from 'react';

import { isActiveNegativeBrandTerm } from 'src/data/brandTerm';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { BrandTermsStore } from 'src/store';

const useBrandTermsState = createStateSelectorHook(BrandTermsStore, ['brandTerms']);

export const useBrandVoiceBrandTerms = () => {
  const { brandTerms } = useBrandTermsState();
  return useMemo(() => brandTerms.filter(isActiveNegativeBrandTerm), [brandTerms]);
};
